// Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
//
// This software is the property of WSO2 LLC. and its suppliers, if any.
// Dissemination of any information or reproduction of any material contained
// herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
// You may not alter or remove any copyright or other notice from copies of this content.

import * as React from 'react';
import { useEffect } from 'react';
import { useGetApi } from '../../data/hooks/api';
import { RESOURCE_SERVER_URLS } from '../../data/configs/spl-config';
import DefaultTable from '../DefaultTable';
import { useAuthContext } from '@asgardeo/auth-react';
import * as Types from "../../data/utils/types";
import Search from '../Search';
import { useNavigate } from 'react-router-dom';

type ListMyAccountsProps = {
   active: boolean;
};

export default function ListMyAccounts(props: ListMyAccountsProps): JSX.Element {

   const [page, setPage] = React.useState(0);
   const [rowsPerPage, setRowsPerPage] = React.useState(10);
   const { state } = useAuthContext();

   const apiUrl = RESOURCE_SERVER_URLS[0] + `/accounts?email=${state.email}&offset=${page * rowsPerPage}&limit=${rowsPerPage}&active=${props.active}`;
   const { data, loading, error, getApiData } = useGetApi<Types.AccountDetails[]>({ url: apiUrl, headers: { "accept": "application/json" } });
   const colNameArray = ["Number", "Name", "Region", "ARR", "Account Manager", "Technical Owner"];
   const colAttributeArray = ['number', 'name', 'region', 'arr', 'accountManager', 'technicalOwner'];
   const navigate = useNavigate();

   const handleAccountTableRowClick = (rowData: Types.AccountDetails) => {
      navigate(`/support/accounts/${rowData.number}`);
   };

   useEffect(() => {
      getApiData(apiUrl);
   }, [rowsPerPage, page, props.active]);

   const [showTable, setShowTable] = React.useState(true);

   return (
      <>
         <Search setShowTable={setShowTable} searchOption="myAccount" />
         {showTable &&
            <DefaultTable data={data} loading={loading} error={error} page={page}
               setPage={setPage} rowsPerPage={rowsPerPage} setRowsPerPage={setRowsPerPage}
               colNameArray={colNameArray} colAttributeArray={colAttributeArray}
               handleRowClick={handleAccountTableRowClick} />
         }
      </>
   )
}
